import React from 'react';
import clsx from 'clsx';
import { preparedShare } from '../../../../../features/wmsOrders/wmsOrdersUtils';
import { formatQuantity } from '../../../../../utils/inventoryLabels';

/**
 * How much of the order is prepared, as a bar. It is the picker's question.
 *
 * Without product lines there is no bar to draw, and one at zero would lie:
 * it is not that preparing is pending, it is that there is nothing to prepare.
 * The sheet and the manual form create no lines, and that is most orders.
 *
 * @param {object} props
 * @param {object} props.order - A row of `wms/orders/`.
 */
export const PreparedCell = ({ order }) => {
  const share = preparedShare(order);

  if (share === null) {
    return (
      <span
        data-testid="order-no-lines"
        title="Este pedido entró sin detalle de productos, así que no hay nada que reservar ni pickear. Su estado sale del envío."
        className="text-xs text-text-muted"
      >
        Sin detalle
      </span>
    );
  }

  return (
    <div className="flex flex-col min-w-[120px]">
      <span className="font-semibold tabular-nums">
        {formatQuantity(order.prepared_units || 0)} / {formatQuantity(order.requested_units || 0)}
        <span className="ml-1 text-xs font-normal text-text-muted">un</span>
      </span>
      <div
        role="progressbar"
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={share}
        aria-label={`Preparado de la orden ${order.id}`}
        data-testid="order-prepared-bar"
        className="mt-1.5 h-1.5 rounded-full bg-ninja-gray dark:bg-[#2d2d2d] overflow-hidden"
      >
        <div
          className={clsx('h-full rounded-full', share === 100 ? 'bg-success' : 'bg-ninja-green')}
          style={{ width: `${share}%` }}
        />
      </div>
    </div>
  );
};
